import '../../../../../themes/AvailabilityCalendar.scss';
import React from 'react';
import { DotIcon } from '../../../../../images/icons/DotIcon';

export const DayIcon = ({  isAvailability, isToday }) => {

  if (isAvailability) {
    return (
      <div className="bg-icon">
        <DotIcon size={34} color="#6ACE8B" />
      </div>
    );
  }

  if (isToday) {
    return (
      <div className="bg-icon">
        <DotIcon size={34} />
      </div>
    );
  }

  return null;
};
